import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import IconButton from '@material-ui/core/IconButton';
import { makeStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';

const useStyles = makeStyles((theme) => ({
    paper: {
        position: 'relative',
        width: '100%',
        maxWidth: 500,
        padding: 30,
        borderRadius: 8,
        boxSizing: 'border-box',
        textAlign: 'left',
        [theme.breakpoints.down('xs')]: {
            margin: 16,
            padding: 24,
        },
    },
    closeButton: {
        position: 'absolute',
        top: 12,
        right: 12,
        color: '#9CA3AF',
    },
    title: {
        margin: '0 0 16px 0',
        paddingRight: 32,
        fontSize: 18,
        fontWeight: 700,
        color: '#111827',
    },
    paragraph: {
        margin: '0 0 14px 0',
        fontSize: 14,
        lineHeight: '21px',
        color: '#6B7280',
        '&:last-of-type': {
            marginBottom: 0,
        },
    },
    actions: {
        display: 'flex',
        justifyContent: 'flex-end',
        flexWrap: 'wrap',
        gap: '10px',
        marginTop: '24px',
    },
    button: {
        height: 40,
        padding: '0 18px',
        borderRadius: 6,
        fontSize: 14,
        textTransform: 'none',
        boxShadow: 'none',
    },
    secondaryButton: {
        backgroundColor: '#FFFFFF',
        border: '1px solid #D1D5DB',
        color: '#374151',
        '&:hover': {
            backgroundColor: '#F9FAFB',
        },
    },
    primaryButton: {
        backgroundColor: '#1045E8',
        color: '#FFFFFF',
        fontWeight: 600,
        '&:hover': {
            backgroundColor: '#0D38BD',
            boxShadow: 'none',
        },
    },
}));

/**
 * Lembrete diário para o gestor/subgestor responder o suitability do cliente
 * selecionado. Quem decide se aparece é o servidor (shouldShowSuitabilityNotice).
 */
export default function SuitabilityNoticeModal({ open, onClose, onAnswer }) {

    const classes = useStyles();

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth={false}
            PaperProps={{ className: classes.paper, elevation: 3 }}>

            <IconButton
                aria-label='Fechar'
                size='small'
                className={classes.closeButton}
                onClick={onClose}>
                <CloseIcon fontSize='small' />
            </IconButton>

            <h2 className={classes.title}>Complete seu perfil de investidor</h2>

            <p className={classes.paragraph}>
                Identificamos que o <b>Suitability</b> do seu RPPS não está vigente. A avaliação do perfil de investidor tem validade de 2 anos e precisa ser renovada.
            </p>
            <p className={classes.paragraph}>
                O <b>Suitability</b> é exigido pela regulamentação para garantir que as aplicações estejam adequadas ao perfil de risco do instituto.
            </p>
            <p className={classes.paragraph}>
                O preenchimento leva poucos minutos. Clique em <b>Responder Suitability</b> para iniciar o questionário.
            </p>

            <div className={classes.actions}>
                <Button
                    variant='outlined'
                    className={[classes.button, classes.secondaryButton].join(' ')}
                    onClick={onClose}>
                    Fechar
                </Button>
                <Button
                    variant='contained'
                    className={[classes.button, classes.primaryButton].join(' ')}
                    onClick={onAnswer}>
                    Responder Suitability
                </Button>
            </div>
        </Dialog>
    );
}
